import { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";
import { Logo } from "./Logo";
import { NAV } from "@/lib/content";
import { CartButton } from "./Cart";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${scrolled || open ? "bg-[#050505]/80 backdrop-blur-xl border-b border-white/10" : "border-b border-transparent"}`}
    >
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 md:px-12">
        <Logo />
        <nav className="hidden items-center gap-9 md:flex">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) => `link-u text-sm ${isActive ? "text-white" : "text-zinc-400 hover:text-white"} transition-colors`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <span className="hidden sm:block">
            <Link to="/products/bundle" data-testid="header-cta-button" className="btn-cta !py-2.5 !px-4 text-sm">
              Get the Bundle
            </Link>
          </span>
          <CartButton />
          <button data-testid="mobile-menu-toggle" aria-label="Menu" onClick={() => setOpen((o) => !o)} className="p-2 text-white md:hidden">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      <AnimatePresence>
        {open && (
          <motion.nav initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0 }}
            className="overflow-hidden border-t border-white/10 bg-[#050505] md:hidden" data-testid="mobile-menu">
            <div className="flex flex-col px-6 py-6">
              {NAV.map((n) => (
                <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="font-display py-3 text-2xl text-white">{n.label}</Link>
              ))}
              <Link to="/products/bundle" onClick={() => setOpen(false)} className="btn-cta mt-6" data-testid="mobile-menu-cta">Get the Bundle</Link>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
